// ═══════════════════════════════════════════════════════════════
// Iter 250 · iPad Version Badge
// A tiny bottom-left corner label showing the running JS build hash
// so a stale iPad cache after deploy is spotted in one glance.
//
// Hidden by default (opacity 0.12) so it doesn't distract clients,
// but tap-to-reveal expands it with the "loaded at" timestamp — a
// staff member can peek without pulling out DevTools.
// ═══════════════════════════════════════════════════════════════
import { useState } from "react";
import { BUILD_HASH, LOADED_AT } from "../lib/buildVersion";

export function VersionBadge() {
  const [expanded, setExpanded] = useState(false);

  const style = {
    position: "fixed",
    left: 6,
    bottom: 6,
    zIndex: 5,                    // sits below toasts (10+), above content
    fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
    fontSize: expanded ? 10 : 9,
    lineHeight: 1.15,
    color: expanded ? "#111" : "#111",
    background: expanded ? "rgba(255, 246, 200, 0.94)" : "rgba(0, 0, 0, 0.045)",
    border: expanded ? "1px solid rgba(184,145,47,0.55)" : "1px solid transparent",
    padding: expanded ? "5px 8px" : "2px 5px",
    borderRadius: 6,
    opacity: expanded ? 1 : 0.32,
    pointerEvents: "auto",
    cursor: "pointer",
    userSelect: "none",
    transition: "opacity 160ms ease, background 160ms ease, padding 160ms ease",
    boxShadow: expanded ? "0 3px 12px rgba(0,0,0,0.15)" : "none",
    letterSpacing: "0.02em",
  };

  return (
    <button
      type="button"
      aria-label={`Build ${BUILD_HASH}, loaded ${LOADED_AT}`}
      onClick={() => setExpanded((v) => !v)}
      data-testid="version-badge"
      style={style}
    >
      {expanded ? (
        <span>
          <b>build</b> {BUILD_HASH}
          <br />
          <span style={{ color: "#6a5a1a" }}>loaded {LOADED_AT}</span>
        </span>
      ) : (
        <span>v.{BUILD_HASH}</span>
      )}
    </button>
  );
}

export default VersionBadge;
